import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { cn } from '../../lib/utils';
interface AccordionItemProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
}
export function AccordionItem({
  title,
  children,
  defaultOpen = false,
  className
}: AccordionItemProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className={cn('border-b border-slate-200 last:border-0', className)} data-id="element-265">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between py-4 text-left font-medium text-slate-900 hover:text-emerald-600 transition-colors focus:outline-none" data-id="element-266">
        <span className="text-base md:text-lg" data-id="element-267">{title}</span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="ml-4 flex-shrink-0 text-slate-400" data-id="element-268">
          <ChevronDown className="h-5 w-5" data-id="element-269" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-270">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-271">
            <div className="pb-4 text-slate-600 text-sm md:text-base leading-relaxed" data-id="element-272">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}